/**
 * Valores iniciais do formulário de Categoria Financeira.
 * Usado no Formik para o cadastro/edição de categorias do Plano de Contas (DRE).
 */
export const financialCategoryDefaults = {
    name: "",                    // "Mensalidades", "Aluguel", "Salários"
    type: "INCOME",              // "INCOME" (Receita) ou "EXPENSE" (Despesa)
    parentId: null,              // ID da categoria-pai (para subcategorias hierárquicas na DRE)
    parentName: "",              // Nome denormalizado da categoria-pai
    order: 0,                    // Ordem de exibição no relatório DRE
    isSystem: false,             // Categorias padrão (seed) que não podem ser excluídas pelo usuário
    status: "active",            // "active" | "inactive"
};
